module.exports = __webpack_public_path__ + "static/media/PISOS PRATIC.3277c73a.png";